import { BrowserPersistence } from '@/util';

const storage = new BrowserPersistence();

const storeCode = storage.getItem('store_view_code') || process.env.NEXT_PUBLIC_STORE_VIEW_CODE;
const storeSecureBaseMediaUrl = {};

JSON.parse(process.env.NEXT_PUBLIC_AVAILABLE_STORE_VIEWS).forEach(store => {
  storeSecureBaseMediaUrl[store.store_code] = store.secure_base_media_url;
});

let mediaBackend = storage.getItem('store_view_secure_base_media_url') || storeSecureBaseMediaUrl[storeCode];

if (!mediaBackend) {
  mediaBackend = 'https://backend.test/media/';
}

export const getOriginalImageUrl = file => {
  if (!file) return '';
  const base = mediaBackend.endsWith('/') ? mediaBackend : mediaBackend + '/';
  const path = file.startsWith('/') ? file.slice(1) : file;
  return `${base}catalog/product/${path}`;
};
